export default {
  office: {
    breadcrumbHome: 'Home',
    breadcrumbSolutions: 'Solutions',
    breadcrumbCurrent: 'Office & practice',
    hero: {
      eyebrow: 'Office & practice',
      title: 'Discreet surveillance for working environments',
      lead: 'Reception, corridors, sensitive areas – we plan camera systems that protect without unsettling employees or patients.',
    },
    areas: {
      title: 'Areas of use in offices and practices',
      lead: 'Modern offices and practices need unobtrusive security technology. We integrate cameras discreetly into the architecture.',
      items: {
        '0': { title: 'Reception', desc: 'The first impression – and the first surveillance point. Cameras at reception document visitors and secure access.' },
        '1': { title: 'Corridors & passages', desc: 'Long corridors and transitions are often blind spots. Compact ceiling cameras close the gaps unobtrusively.' },
        '2': { title: 'Meeting rooms', desc: 'Not every meeting needs recording. We set up cameras so only relevant areas are captured.' },
        '3': { title: 'Server room & technology', desc: 'The room where your data lives deserves special attention. Access and activity are reliably logged.' },
        '4': { title: 'Practice reception', desc: 'Discretion matters in practices. We mount reserved cameras that do not unsettle patients – and protect sensitive zones.' },
        '5': { title: 'Car park & entrance', desc: 'Outdoor car parks and entrances are particularly at risk at night. Weatherproof cameras with night vision keep the overview.' },
      },
    },
    access: {
      eyebrow: 'Access & control',
      title: 'Who may see what?',
      lead: 'A camera system in the office is only accepted when the rights are clearly regulated. We set up differentiated access rights and document every use.',
      items: {
        '0': { title: 'User management', desc: 'Each person receives exactly the rights they need – from live view to playback of recordings.' },
        '1': { title: 'Privacy masking', desc: 'Areas such as break rooms or changing rooms are technically hidden – directly in camera or recorder.' },
        '2': { title: 'Event log', desc: 'Who viewed what and when? A complete access log provides traceable control.' },
      },
    },
    privacy: {
      eyebrow: 'Data protection',
      title: 'Data protection in the workplace',
      lead: 'Employees and visitors enjoy special protection. We implement your surveillance so it remains compliant and fair – and advise you on documenting the necessity.',
      list: {
        '0': 'Recording only where operationally necessary',
        '1': 'Add signage for employees and visitors',
        '2': 'No surveillance of changing rooms, toilets or break rooms',
        '3': 'Access to recordings only for expressly authorised persons',
        '4': 'Documentation of the operational necessity',
      },
      note: 'Note: Surveillance of workplaces is subject to strict legal requirements. We advise you technically, but do not replace legal advice.',
    },
    cta: {
      title: 'Discreet. Privacy-conscious. Reliable.',
      lead: 'We plan your office or practice system so it protects – and disturbs no one in everyday life. Without obligation and transparently.',
      primary: 'Arrange a consultation',
      secondary: 'Start the Camera Planner',
    },
  },
};